import { errors } from '../translates'
import useCommonDict from './useCommonDict'
import { useOrgChainsQuery } from '../api/react-query/org'
import { sortByName } from '../helper'

export default function useChains (data, options) {
  return useCommonDict({
    errorMessage: errors.chains,
    queryMethod: useOrgChainsQuery,
    queryBody: data,
    queryOptions: options,
    successCallback: data => [...sortByName(data?.result || [])]
  })
}
